<div class="padding-dialog">

  <div class='flex'>
    <div>
      <h1 mat-dialog-title align="center">{{data.title | label}}</h1>
      <div mat-dialog-content class="spin-theme">
        <p align="center">{{data.message | label}}</p>
        <ul>- codice fiscale</ul>
        <ul>- nome</ul>
        <ul>- cognome</ul>
        <ul>- sesso</ul>
        <ul>- comune di nascita</ul>
        <ul>- data di nascita</ul>
      </div>

    </div>
    <button mat-icon-button mat-dialog-close *ngIf="data.dialogClose">
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <div mat-dialog-actions align="center">

    <button *ngIf="data.buttonConfirmText" mat-flat-button [color]="data.confirmButtonColor || 'primary'"
      [mat-dialog-close]="true">{{data.buttonConfirmText}}</button>
  </div>
</div>
